import { arrayMove } from 'react-sortable-hoc';
import {
  ADD_LAYOUT_TO_PAGE,
  ADD_TEXTURE_TO_PAGE,
  CREATE_PAGE,
  DELETE_PAGE,
  TOGGLE_IS_ACTIVE,
  REMOVE_PLACEHOLDERS_FROM_PAGE,
  ADD_DROPPED_IMAGE,
  REMOVE_TEXTURE_FROM_PAGE,
  REMOVE_DROPPED_IMAGE,
  REMOVE_DROPPED_IMAGES,
  UPDATE_PAGES_ORDER,
  CHANGE_IMAGE,
  ADD_COVER_TO_PAGE,
  ADD_DROPPED_IMAGE_CHANGED_LAYOUT,
  REMOVE_CHANGED_IMAGE,
  REORDER_PAGES,
  REORDER_DROPPED_IMAGES,
  ASSIGNE_IMAGE_ID_TO_PAGE_PLACEHOLDERS,
  CHANGE_PAGES_BACKGROUND_COLOR,
  CHANGE_PAGES_BACKGROUND_COLOR_BY_ID,
  LOAD_PAGES_BY_BOOK_ID,
  ADD_TEXT_TO_PAGE,
  DELETE_TEXT_FROM_PAGE,
  ADD_BACKGROUND_IMAGE_TO_PAGE,
  CHANGE_PAGES_BACKGROUND_IMAGES,
  DELETE_PAGES,
  ADD_BACKGROUND_PLACEHOLDER_TO_PAGE,
  ADD_BACKGROUND_PROP_TO_PAGE,
} from '../../action-types/entities/pages';

import { generateId, convertObjectToArray } from '../../helpers/index';

export const STATE_KEY = 'pages';

export const pages = (
  state = {
    byId: {},
    allIds: [],
  },
  action,
) => {
  switch (action.type) {
    case LOAD_PAGES_BY_BOOK_ID: {
      return action.bookState;
    }

    case CREATE_PAGE: {
      const emptyPage = {
        droppedImages: [],
        layout: 0,
        placeholders: {},
        backgroundPlaceholders: {},
        order: 0,
        isActive: false,
        id: 0,
        backgroundImages: {},
        texts: [],
      };
      const page = Object.assign({}, emptyPage, action.page);
      page.id = generateId(state.allIds);

      return {
        byId: {
          ...state.byId,
          [page.id]: page,
        },
        allIds: [...state.allIds, page.id],
      };
    }

    case DELETE_PAGES: {
      const { excludeID } = action;

      const newById = {};
      const newAllId = [];

      const { byId, allIds } = state;

      allIds.map((element) => {
        if (element === excludeID) {
          newAllId.push(element);
        }
      });

      Object.values(byId).forEach((element) => {
        if (element.id === excludeID) {
          Object.assign(newById, { 10: element });
        }
      });

      return Object.assign({}, state, {
        byId: newById,
        allIds: newAllId,
      });
    }

    case DELETE_PAGE: {
      const { pageId } = action;
      const { byId, allIds } = state;
      const pagesById = {};
      const activePageIndex = allIds.indexOf(pageId);

      let setPageToActive;

      if (allIds[activePageIndex + 1] !== undefined) {
        setPageToActive = allIds[activePageIndex + 1];
      } else if (allIds[activePageIndex - 1] !== undefined) {
        setPageToActive = allIds[activePageIndex - 1];
      } else {
        setPageToActive = false;
      }

      const pageOrder = byId[pageId].order;

      if (setPageToActive) {
        for (const page of byId) {
          const Page = Object.assign({}, byId[page.id]);
          Page.id !== pageId ? (pagesById[Page.id] = Page) : '';

          if (Page.id === setPageToActive) {
            pagesById[Page.id].isActive = true;
          }

          if (Page.order > pageOrder) {
            pagesById[Page.id].order -= 1;
          }
        }

        const allId = allIds.filter(id => id !== pageId);
        return Object.assign({}, state, {
          byId: pagesById,
          allIds: allId,
        });
      }
      break;
    }

    case ADD_COVER_TO_PAGE: {
      const { pageId } = action;
      return {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            isCover: true,
          },
        },
        allIds: [...state.allIds],
      };
    }

    case ADD_LAYOUT_TO_PAGE: {
      const { layoutId, pageId } = action;
      return {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            layout: layoutId,
          },
        },
        allIds: [...state.allIds],
      };
    }

    case REMOVE_PLACEHOLDERS_FROM_PAGE: {
      const { pageId } = action;
      return {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            placeholders: {},
          },
        },
        allIds: [...state.allIds],
      };
    }

    case REMOVE_TEXTURE_FROM_PAGE: {
      const { pageId, placeholderId } = action;
      const { placeholders } = state.byId[pageId];
      const arr = placeholders.filter(item => item !== placeholderId);

      return {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            placeholders: arr,
          },
        },
        allIds: [...state.allIds],
      };
    }

    case REMOVE_DROPPED_IMAGES: {
      const { pageId } = action;
      return {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            droppedImages: {},
          },
        },
        allIds: [...state.allIds],
      };
    }


    case ADD_DROPPED_IMAGE: {
      const {
        pageId,
        isCover,
        placeholderId,
      } = action;


      const droppedImagesFromState = state.byId[pageId].droppedImages;
      const droppedImagesArray = convertObjectToArray(droppedImagesFromState);
      const randomId = isCover ? placeholderId : generateId(Object.keys(state.byId[pageId].droppedImages));
      const order = droppedImagesArray.length;


      return {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            droppedImages: {
              ...droppedImagesFromState,
              [randomId]: {
                id: randomId,
                imageId: action.imageId,
                order,
                fixedOrder: order,
              },
            },
          },
        },
        allIds: [...state.allIds],
      };
    }

    case REMOVE_DROPPED_IMAGE: {
      const { pageId, imageId } = action;
      const { byId } = state;
      const pageDroppedImages = byId[pageId];
      const droppedImages = {};

      Object.values(pageDroppedImages.droppedImages).forEach((images) => {
        const droppedImage = Object.assign({}, byId[pageId]);

        if (pageDroppedImages.isBackFlyLeaf || pageDroppedImages.isFrontFlyLeaf) {
          return droppedImages;
        } else if (droppedImage.droppedImages[images.id].id !== parseInt(imageId, 10)) {
          droppedImages[images.id] = droppedImage.droppedImages[images.id];
        }
      });

      return Object.assign({}, state, {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            droppedImages,
          },
        },
        allIds: [...state.allIds],
      });
    }

    case REMOVE_CHANGED_IMAGE: {
      const { pageId, imageId } = action;

      return Object.assign({}, state, {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            droppedImages: {
              ...state.byId[pageId].droppedImages,
              [imageId]: {
                ...state.byId[pageId].droppedImages[imageId],
                imageId: 0,
              },
            },
          },
        },
        allIds: [...state.allIds],
      });
    }

    case ADD_TEXTURE_TO_PAGE: {
      const { placeholderId, pageId } = action;

      const randomId = generateId(Object.keys(state.byId[pageId].placeholders));

      const textureOrder =
        Object.keys(state.byId[pageId].placeholders).length === 0
          ? 0
          : Object.keys(state.byId[pageId].placeholders).length;

      const copiedCurrentPage = Object.assign({}, state.byId[pageId]);

      copiedCurrentPage.placeholders = {
        ...state.byId[pageId].placeholders,
        [randomId]: {
          placeholderId,
          order: textureOrder,
          id: randomId,
          imageId: 0,
        },
      };

      const newById = Object.assign({}, state.byId);
      newById[pageId] = Object.assign({}, copiedCurrentPage);
      return Object.assign({}, state, { byId: newById });
    }

    case ADD_BACKGROUND_PLACEHOLDER_TO_PAGE: {
      const { placeholderId, pageId } = action;

      const randomId = generateId(Object.keys(state.byId[pageId].backgroundPlaceholders));

      const textureOrder =
        Object.keys(state.byId[pageId].backgroundPlaceholders).length === 0
          ? 0
          : Object.keys(state.byId[pageId].backgroundPlaceholders).length;

      const copiedCurrentPage = Object.assign({}, state.byId[pageId]);

      copiedCurrentPage.backgroundPlaceholders = {
        ...state.byId[pageId].backgroundPlaceholders,
        [randomId]: {
          backgroundPlaceholderId: placeholderId,
          order: textureOrder,
          id: randomId,
        },
      };

      const newById = Object.assign({}, state.byId);
      newById[pageId] = Object.assign({}, copiedCurrentPage);
      return Object.assign({}, state, { byId: newById });
    }

    case TOGGLE_IS_ACTIVE: {
      const { pageId } = action;
      const pagesById = {};
      const statePages = state.byId;

      for (const id in statePages) {
        if (id in statePages) {
          const page = Object.assign({}, statePages[id]);
          page.isActive = pageId === parseInt(id, 10);
          pagesById[id] = page;
        }
      }
      return Object.assign({}, state, { byId: pagesById });
    }

    case UPDATE_PAGES_ORDER: {
      const { pagesOrderedArray, oldIndex, newIndex } = action;
      const pagesByOrder = {};
      const orderArray = [];

      for (const page of pagesOrderedArray) {
        orderArray[page.order] = page.id;
      }

      const newOrder = arrayMove(orderArray, oldIndex, newIndex);

      newOrder.map((order, id) => {
        const pageOrder = Object.assign({}, pagesOrderedArray[order]);
        pagesByOrder[order] = pageOrder;
        pagesByOrder[order].order = id;
        return pagesByOrder;
      });
      return Object.assign({}, state, {
        byId: pagesByOrder,
        allIds: [...state.allIds],
      });
    }

    case CHANGE_IMAGE: {
      const {
        pageId,
        dragplaceholderId,
        dragOrder,
        dropplaceholderId,
        targetOrder,
      } = action;

      return {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            droppedImages: {
              ...state.byId[pageId].droppedImages,
              [dragplaceholderId]: {
                ...state.byId[pageId].droppedImages[dragplaceholderId],
                order: targetOrder,
              },
              [dropplaceholderId]: {
                ...state.byId[pageId].droppedImages[dropplaceholderId],
                order: dragOrder,
              },
            },
          },
        },
        allIds: [...state.allIds],
      };
    }

    case ADD_DROPPED_IMAGE_CHANGED_LAYOUT: {
      const { pageId, imageId, droppedImageId } = action;

      return {
        byId: {
          ...state.byId,
          [pageId]: {
            ...state.byId[pageId],
            droppedImages: {
              ...state.byId[pageId].droppedImages,
              [droppedImageId]: {
                ...state.byId[pageId].droppedImages[droppedImageId],
                imageId,
              },
            },
          },
        },
        allIds: [...state.allIds],
      };
    }

    case REORDER_PAGES: {
      const { byId } = state;
      const pagesById = {};

      for (const page of byId) {
        const pageOrder = Object.assign({}, byId[page.id]);
        pagesById[page.id] = pageOrder;
        const { isBackFlyLeaf, isCover, isFrontFlyLeaf } = pageOrder;

        if (!isCover && !isBackFlyLeaf && !isFrontFlyLeaf) {
          pagesById[page.id].order = pageOrder.order + 1;
        }
      }

      return Object.assign({}, state, {
        byId: pagesById,
        allIds: [...state.allIds],
      });
    }

    case REORDER_DROPPED_IMAGES: {
      const { page, reorderedDroppedImages } = action;
      const newById = Object.assign({}, state.byId);
      newById[page.id].droppedImages = Object.assign(
        {},
        reorderedDroppedImages,
      );
      return Object.assign({}, state, { byId: newById });
    }

    case ASSIGNE_IMAGE_ID_TO_PAGE_PLACEHOLDERS: {
      const { currentPage, entitiesPlaceholders } = action;

      const copiedCurrentPage = Object.assign({}, currentPage);
      const copiedEntitiesPlaceholders = Object.assign({}, entitiesPlaceholders);
      Object.keys(copiedEntitiesPlaceholders.byId).forEach((epKey) => {
        Object.keys(copiedCurrentPage.droppedImages).forEach((diKey) => {
          const imageKeyId = parseInt(copiedEntitiesPlaceholders.byId[epKey].image, 10);

          if (copiedCurrentPage.droppedImages[imageKeyId] && parseInt(copiedCurrentPage.droppedImages[imageKeyId].imageId, 10) === parseInt(copiedCurrentPage.droppedImages[diKey].imageId, 10)) {
            const placeholderId = copiedEntitiesPlaceholders.byId[epKey].id;
            const { imageId } = copiedCurrentPage.droppedImages[diKey];
            const { order } = copiedCurrentPage.droppedImages[diKey];

            Object.keys(copiedCurrentPage.placeholders).forEach((pplKey) => {
              if (copiedCurrentPage.placeholders[pplKey].placeholderId === placeholderId) {
                copiedCurrentPage.placeholders[pplKey].imageId = imageId;
                copiedCurrentPage.placeholders[pplKey].order = order;
              }
            });
          }

          const pageId = copiedCurrentPage.id;
          const newById = Object.assign({}, state.byId);
          newById[pageId] = Object.assign(
            {},
            copiedCurrentPage,
          );
          return Object.assign({}, state, { byId: newById });
        });
      });
    }

    case CHANGE_PAGES_BACKGROUND_COLOR: {
      const { color } = action;
      const { byId } = state;
      const pagesById = {};

      for (const page of byId) {
        const pageBackgroundColor = Object.assign({}, byId[page.id]);
        pagesById[page.id] = pageBackgroundColor;
        pagesById[page.id].backgroundColor = color;
      }

      return Object.assign({}, state, {
        byId: pagesById,
        allIds: [...state.allIds],
      });
    }

    case CHANGE_PAGES_BACKGROUND_COLOR_BY_ID: {
      const {
        pageId,
        order,
        color,
      } = action;

      const { byId } = state;
      const pagesById = {};

      for (const page of byId) {
        const pageBackgroundColor = Object.assign({}, byId[page.id]);
        pagesById[page.id] = pageBackgroundColor;
        if (pagesById[page.id].id === pageId || pagesById[page.id].order > order) {
          pagesById[page.id].backgroundColor = color;
        }
      }

      return Object.assign({}, state, {
        byId: pagesById,
        allIds: [...state.allIds],
      });
    }

    case DELETE_TEXT_FROM_PAGE: {
      const { textId } = action;
      const { byId } = state;
      const pagesById = {};

      const activePage = Object.values(byId).find(element => element.isActive);
      for (const page of byId) {
        const pageTextId = Object.assign({}, byId[page.id]);
        pagesById[page.id] = pageTextId;
        if (pagesById[page.id].id === activePage.id) {
          pagesById[page.id].texts = activePage.texts.filter(element => element !== textId);
        }
      }

      return Object.assign({}, state, {
        byId: pagesById,
        allIds: [...state.allIds],
      });
    }

    case ADD_TEXT_TO_PAGE: {
      const {
        pageId,
        textId,
      } = action;
      const { byId } = state;
      const pagesById = {};

      for (const page of byId) {
        const currentPage = Object.assign({}, byId[page.id]);
        pagesById[page.id] = currentPage;
        if (pagesById[page.id].id === pageId) {
          if (!('texts' in pagesById[page.id])) {
            pagesById[page.id].texts = [];
          }
          pagesById[page.id].texts.push(textId);
        }
      }

      return Object.assign({}, state, {
        byId: pagesById,
        allIds: [...state.allIds],
      });
    }


    case ADD_BACKGROUND_IMAGE_TO_PAGE: {
      const {
        category,
        layouts,
        backgrounds,
        fileName,
        types,
      } = action;
      const { byId } = state;
      const pagesById = {};

      for (const page of byId) {
        const currentPage = Object.assign({}, byId[page.id]);
        pagesById[page.id] = currentPage;

        let backgroundProps = {};

        const stickerBg = Object.values(backgrounds).find(el => el.name === layouts[pagesById[page.id].layout].type);
        if (stickerBg) {
          stickerBg.items.forEach((el) => {
            el.items.forEach((item) => {
              const selectedCategory = item.images.find(bg => bg.fileName === fileName);
              if (selectedCategory) {
                backgroundProps = Object.assign({}, byId[page.id].backgroundImages, {
                  thumbnail: selectedCategory.editorBackgroundUrl,
                  full: selectedCategory.fullUrl,
                  sizes: selectedCategory.sizes,
                  type: types || byId[page.id].backgroundImages.type,
                  category,
                });
              }
            });
          });
        }


        pagesById[page.id].backgroundImages = backgroundProps;
      }

      return Object.assign({}, state, {
        byId: pagesById,
        allIds: [...state.allIds],
      });
    }

    case ADD_BACKGROUND_PROP_TO_PAGE: {
      const { property, value } = action;
      const { byId } = state;
      const pagesById = {};


      for (const page of byId) {
        const currentPage = Object.assign({}, byId[page.id]);
        pagesById[page.id] = currentPage;
        // if (pagesById[page.id].id === selectedPage.id) {
        const copyProperty = Object.assign({}, pagesById[page.id].backgroundImages, { [property]: value });
        pagesById[page.id].backgroundImages = copyProperty;
        // }
      }

      return Object.assign({}, state, {
        byId: pagesById,
        allIds: [...state.allIds],
      });
    }


    case CHANGE_PAGES_BACKGROUND_IMAGES: {
      const { thumbnail, full, sizes } = action;
      const { byId } = state;
      const pagesById = {};

      for (const page of byId) {
        const pageBackgroundColor = Object.assign({}, byId[page.id]);
        pagesById[page.id] = pageBackgroundColor;
        pagesById[page.id].backgroundColor = null;
        pagesById[page.id].backgroundImages = Object.assign({}, {
          thumbnail,
          full,
          sizes,
        }, pagesById[page.id].backgroundImages);
      }

      return Object.assign({}, state, {
        byId: pagesById,
        allIds: [...state.allIds],
      });
    }


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/entities/pages.js